<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AuctionList" });
import * as API from "../../services/api.js";
import { AUCTION_STORE, AUCTION_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable, derived } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $AUCTION_HASH;
const syncFromGlobalStore = (data) => {
    const AUCTIONS = get(STORE).map((auction) => {
        const KEY = auction._.key;
        if (!(KEY in data)) {
            return auction;
        }
        return data[KEY];
    });
    STORE.set(AUCTIONS);
};
const setStore = (auctions) => {
    STORE.set(auctions);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterAuctions({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onAuctionHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $AUCTION_HASH;
    isLoading = true;
    void API.filterAuctions({ ...parameters }).then(setStore);
};
$: onAuctionHashChange($AUCTION_HASH);
onMount(() => {
    unsubscribe = AUCTION_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
export const COUNT = derived(STORE, ($STORE) => $STORE.length);
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot auctions = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}